module.exports = __webpack_public_path__ + "static/media/internal_env_1_product_image_1.9be54d72.webp";